import links from "@/links/links";
import qs from "qs";

export default {
  actions: {
    FETCH(buildingId) {
      return this.get(links.VOTING_CATEGORY_FETCH(buildingId), {
        dataKey: "hydra:member",
      });
    },
    FETCH_WITH_RELATED(buildingId) {
      return this.get(links.VOTING_CATEGORY_FETCH_WITH_RELATED(buildingId), {
        dataKey: "hydra:member",
      });
    },
    FETCH_WITH_CHARGE_GENERAL(agencyId) {
      return this.get(links.VOTING_CATEGORY_FETCH_WITH_CHARGE_GENERAL(agencyId), {
        dataKey: "hydra:member",
      });
    },
    QUERY_FETCH(agencyId, queryParams) {
      // NOTE: prepare query params
      var processedQueryParams = {};
      // filters
      queryParams.filter.forEach(filter => {
        if (filter.column == "building_id") {
          processedQueryParams["building"] = filter.value;
        } else {
          processedQueryParams[filter.column] = filter.value;
        }
      });
      // order
      processedQueryParams[`order[${queryParams.sort.by}]`] = queryParams.sort.dir.toLowerCase();
      // page
      processedQueryParams.page = queryParams.page;
      processedQueryParams.itemsPerPage = queryParams.itemsPerPage;
      return this.get(links.VOTING_CATEGORY_QUERY_FETCH(), {
        params: processedQueryParams,
        paramsSerializer: params => {
          return qs.stringify(params);
        },
        dataKey: "hydra:member",
      });
    },
    GET(id) {
      return this.get(links.VOTING_CATEGORY_GET(id));
    },
    POST(item) {
      return this.post(links.VOTING_CATEGORY_POST(), item);
    },
    PUT(item) {
      return this.put(links.VOTING_CATEGORY_PUT(item.id), item);
    },
    DELETE(item) {
      return this.delete(links.VOTING_CATEGORY_DELETE(item.id), {
        delete: item.id,
      });
    },
    SET_OTHER_CHARGES_GENERALES_TO_FALSE(buildingId) {
      return this.post(
        links.VOTING_CATEGORY_SET_OTHER_CHARGES_GENERALES_TO_FALSE(),
        {
          building_id: buildingId,
        },
        {
          save: false,
        }
      );
    },
    REGISTER_GET_VOTING_CATEGORIES(meetingId) {
      let params = {};
      if (meetingId) {
        params["meeting_id"] = meetingId;
      }
      return this.get(links.VOTING_CATEGORY_MEETING_REGISTER() + "?" + qs.stringify(params));
    },
    GET_BY_MEETING(meetingId) {
      return this.get(links.VOTING_CATEGORIES_BY_MEETING(meetingId), {
        dataKey: "hydra:member",
      });
    },
    CUSTOM_DELETE(id) {
      return this.delete(links.VOTING_CATEGORY_CUSTOM_DELETE(id), {
        delete: id,
      });
    },
  },
};
